import { Card, ListItemButton, List, ListItemText } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { RoutePaths } from '../routes/AppRoutes';
import { PricesNavigation } from '../common/state/navigation';
import TopAppBar from '../common/components/TopAppBar';

export default function NavigationPrices(): React.JSX.Element {
  const { t } = useTranslation(['common', 'price', 'contracts']);
  const navigate = useNavigate();

  return (
    <>
      <TopAppBar
        configuration="small"
        backTo={RoutePaths.NAVIGATION_MAIN}
        shouldCheckHistory={false}
        title={t('common:prices')}
      />
      <Card sx={{ m: 2, p: 1, borderRadius: 3 }}>
        <List>
          {PricesNavigation.subTabs.map((subTab) => (
            <ListItemButton
              key={subTab.label}
              onClick={() => navigate(subTab.to)}
            >
              <ListItemText>
                {t(subTab.label)}
              </ListItemText>
            </ListItemButton>
          ))}
        </List>
      </Card>
    </>
  );
}
